export enum TipoSituacaoCartaGeradadaEnum {
  ATIVA = 1,
  SUSPENSA = 2,
  IMPEDIDA = 3,
  CANCELADA = 4,
  GERADA = 5,
  TEMPORARIO = 6,
  RETIFICANDO = 7,
  AGUARDANDO_RETIFICACAO = 8,
  RETIFICADO = 10
}
